import axios from "axios";
import moment from "moment";
import jwt_decode from "jwt-decode";
import Rata from "../../../common/mookup/mookup_isRata";
import Rate from "../../../common/mookup/MookupRate.json";
import { logOut } from "../../../common/utils";
import { toast } from "react-toastify";

export default class DetailSanzioneService {
  getIsRata(onSuccess) {
    onSuccess(Rata);
  }

  // getDetailRata(onSuccess){
  //   onSuccess(Rate)
  // }

  getDetailSanzione(idSanzione, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(host + "/api/v1/sanzione/detail/" + idSanzione, configHeaders)
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result.data);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("errore" + error);
          onSuccess("");
        }
      );
  }

  getListStatiSanzione(idSanzione, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(host + "/api/v1/storico/sanzione/find/" + idSanzione, configHeaders)
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result.data);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log(
            "errore " + error
          );
          onSuccess([]);
        }
      );
  }

  saveSanzione(sanzione, onSuccess) {
    sanzione.dataDiEmissione = moment(sanzione.dataDiEmissione, "DD/MM/YYYY HH:mm")
      .toDate()
      .getTime();

    if (sanzione.anagraficaTrasgressore.dataDiNascita)
      sanzione.anagraficaTrasgressore.dataDiNascita = moment(
        sanzione.anagraficaTrasgressore.dataDiNascita,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaTrasgressore.dataRilascioDocumento)
      sanzione.anagraficaTrasgressore.dataRilascioDocumento = moment(
        sanzione.anagraficaTrasgressore.dataRilascioDocumento,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaTrasgressore.isMinorenne)
      sanzione.anagraficaTrasgressore.isMinorenne = 1;
    else sanzione.anagraficaTrasgressore.isMinorenne = 0;

    if (sanzione.isverbaleFattoABordo) sanzione.isverbaleFattoABordo = 1;
    else sanzione.isverbaleFattoABordo = 0;

    if (sanzione.anagraficaPotestaTrasgressore.dataDiNascita)
      sanzione.anagraficaPotestaTrasgressore.dataDiNascita = moment(
        sanzione.anagraficaPotestaTrasgressore.dataDiNascita,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento)
      sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento = moment(
        sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaPotestaTrasgressore.isMinorenne)
      sanzione.anagraficaPotestaTrasgressore.isMinorenne = 1;
    else sanzione.anagraficaPotestaTrasgressore.isMinorenne = 0;
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    // console.log(JSON.stringify(sanzione));
    axios.post(host + "/api/v1/sanzione/save", sanzione, configHeaders).then(
      function (result) {
        if(result.status === 401){
          logOut();
        }
        onSuccess(result.data);
      },
      function (error) {
       if(error.response.status === 401){
          logOut();
        }
        console.log("errore " + error);
        onSuccess("");
      }
    );
  }

  changeStatoAltriStati(sanzione, stato, note, idSanzione,idSato, onSuccess) {
    sanzione.dataDiEmissione = moment(sanzione.dataDiEmissione, "DD/MM/YYYY")
      .toDate()
      .getTime();
    if (sanzione.anagraficaTrasgressore.dataDiNascita)
      sanzione.anagraficaTrasgressore.dataDiNascita = moment(
        sanzione.anagraficaTrasgressore.dataDiNascita,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaTrasgressore.dataRilascioDocumento)
      sanzione.anagraficaTrasgressore.dataRilascioDocumento = moment(
        sanzione.anagraficaTrasgressore.dataRilascioDocumento,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaTrasgressore.isMinorenne)
      sanzione.anagraficaTrasgressore.isMinorenne = 1;
    else sanzione.anagraficaTrasgressore.isMinorenne = 0;
    if (sanzione.anagraficaPotestaTrasgressore.dataDiNascita)
      sanzione.anagraficaPotestaTrasgressore.dataDiNascita = moment(
        sanzione.anagraficaPotestaTrasgressore.dataDiNascita,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento)
      sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento = moment(
        sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaPotestaTrasgressore.isMinorenne)
      sanzione.anagraficaPotestaTrasgressore.isMinorenne = 1;
    else sanzione.anagraficaPotestaTrasgressore.isMinorenne = 0;

    if (sanzione.isverbaleFattoABordo) sanzione.isverbaleFattoABordo = 1;
    else sanzione.isverbaleFattoABordo = 0;

    const request = new Object();
    request.sanzioni = sanzione;
    request.motivazione = note;
    request.stato = stato;
    request.importo = 0;
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    this.avanzaStatoPerDiverseAzioni(request,idSanzione,idSato,onSuccess)

  }


  avanzaStatoPerDiverseAzioni(oggettoSaznioneCompleto, idSanzione, idStatoTo, onSuccess, onError){
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    // const request = new Object();
    // request.sanzioni = oggettoSaznioneCompleto;
    // oggettoSaznioneCompleto.listaStatiTo = {
    //   idStato:idStatoTo,
    //   nomeStato:"Validato"
    // }
    // console.log(oggettoSaznioneCompleto)
    axios
      .put(
        host + "/api/v1/sanzione/changeStato/" + idSanzione + "/" +idStatoTo,
        oggettoSaznioneCompleto,//Oggetto Completo
        configHeaders
      )
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          if(result.status === 200){
            onSuccess(result.data);
          }else{
            if(onError){
              onError()
            }
          }
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }else{
            if(onError){
              onError()
            }
          }
          toast.error(error.response.data !== "" ? error.response.data : "Errore riprova piu tardi", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      );
  }

  SbloccaSaznione(sanzione, stato, note, onSuccess) {
    sanzione.dataDiEmissione = moment(sanzione.dataDiEmissione, "DD/MM/YYYY")
      .toDate()
      .getTime();
    if (sanzione.anagraficaTrasgressore.dataDiNascita)
      sanzione.anagraficaTrasgressore.dataDiNascita = moment(
        sanzione.anagraficaTrasgressore.dataDiNascita,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaTrasgressore.dataRilascioDocumento)
      sanzione.anagraficaTrasgressore.dataRilascioDocumento = moment(
        sanzione.anagraficaTrasgressore.dataRilascioDocumento,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaTrasgressore.isMinorenne)
      sanzione.anagraficaTrasgressore.isMinorenne = 1;
    else sanzione.anagraficaTrasgressore.isMinorenne = 0;
    if (sanzione.anagraficaPotestaTrasgressore.dataDiNascita)
      sanzione.anagraficaPotestaTrasgressore.dataDiNascita = moment(
        sanzione.anagraficaPotestaTrasgressore.dataDiNascita,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento)
      sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento = moment(
        sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaPotestaTrasgressore.isMinorenne)
      sanzione.anagraficaPotestaTrasgressore.isMinorenne = 1;
    else sanzione.anagraficaPotestaTrasgressore.isMinorenne = 0;

    if (sanzione.isverbaleFattoABordo) sanzione.isverbaleFattoABordo = 1;
    else sanzione.isverbaleFattoABordo = 0;

    const request = new Object();
    request.sanzioni = sanzione;
    request.motivazione = note;
    request.stato = stato;
    request.importo = 0;
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .put(
        host + "/api/v1/sanzione/avanzaStato/sblocca",
        request,
        configHeaders
      )
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result.data);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("errore ricerca dettaglio sanzione " + error);
          onSuccess("");
        }
      );
  }


  AgliAttiPerLoscrittoDifensivo(sanzione, note, idSaznione, idStato, onSuccess) {
    sanzione.dataDiEmissione = moment(sanzione.dataDiEmissione, "DD/MM/YYYY")
      .toDate()
      .getTime();
    if (sanzione.anagraficaTrasgressore.dataDiNascita)
      sanzione.anagraficaTrasgressore.dataDiNascita = moment(
        sanzione.anagraficaTrasgressore.dataDiNascita,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaTrasgressore.dataRilascioDocumento)
      sanzione.anagraficaTrasgressore.dataRilascioDocumento = moment(
        sanzione.anagraficaTrasgressore.dataRilascioDocumento,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaTrasgressore.isMinorenne)
      sanzione.anagraficaTrasgressore.isMinorenne = 1;
    else sanzione.anagraficaTrasgressore.isMinorenne = 0;
    if (sanzione.anagraficaPotestaTrasgressore.dataDiNascita)
      sanzione.anagraficaPotestaTrasgressore.dataDiNascita = moment(
        sanzione.anagraficaPotestaTrasgressore.dataDiNascita,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento)
      sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento = moment(
        sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaPotestaTrasgressore.isMinorenne)
      sanzione.anagraficaPotestaTrasgressore.isMinorenne = 1;
    else sanzione.anagraficaPotestaTrasgressore.isMinorenne = 0;

    if (sanzione.isverbaleFattoABordo) sanzione.isverbaleFattoABordo = 1;
    else sanzione.isverbaleFattoABordo = 0;

    const request = new Object();
    request.sanzioni = sanzione;
    request.motivazione = note;
    request.stato = "Agli Atti";
    request.importo = 0;
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    this.avanzaStatoPerDiverseAzioni(sanzione,idSaznione,idStato,onSuccess)
  }

  changeStatoRavOperoso(sanzione, importo, note, idSanzione, idStatoTo, onSuccess) {
    sanzione.dataDiEmissione = moment(sanzione.dataDiEmissione, "DD/MM/YYYY")
      .toDate()
      .getTime();
    if (sanzione.anagraficaTrasgressore.dataDiNascita)
      sanzione.anagraficaTrasgressore.dataDiNascita = moment(
        sanzione.anagraficaTrasgressore.dataDiNascita,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaTrasgressore.dataRilascioDocumento)
      sanzione.anagraficaTrasgressore.dataRilascioDocumento = moment(
        sanzione.anagraficaTrasgressore.dataRilascioDocumento,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaTrasgressore.isMinorenne)
      sanzione.anagraficaTrasgressore.isMinorenne = 1;
    else sanzione.anagraficaTrasgressore.isMinorenne = 0;
    if (sanzione.anagraficaPotestaTrasgressore.dataDiNascita)
      sanzione.anagraficaPotestaTrasgressore.dataDiNascita = moment(
        sanzione.anagraficaPotestaTrasgressore.dataDiNascita,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento)
      sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento = moment(
        sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaPotestaTrasgressore.isMinorenne)
      sanzione.anagraficaPotestaTrasgressore.isMinorenne = 1;
    else sanzione.anagraficaPotestaTrasgressore.isMinorenne = 0;
    if (sanzione.isverbaleFattoABordo) sanzione.isverbaleFattoABordo = 1;
    else sanzione.isverbaleFattoABordo = 0;
    const request = new Object();
    request.sanzioni = sanzione;
    request.motivazione = note;
    request.importo = importo * 100;
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    this.avanzaStatoPerDiverseAzioni(request,idSanzione,idStatoTo,onSuccess)
  }

  changeStato(sanzione, idSaznione, idStato, onSuccess) {
    sanzione.dataDiEmissione = moment(sanzione.dataDiEmissione, "DD/MM/YYYY")
      .toDate()
      .getTime();
    if (sanzione.anagraficaTrasgressore.dataDiNascita)
      sanzione.anagraficaTrasgressore.dataDiNascita = moment(
        sanzione.anagraficaTrasgressore.dataDiNascita,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaTrasgressore.dataRilascioDocumento)
      sanzione.anagraficaTrasgressore.dataRilascioDocumento = moment(
        sanzione.anagraficaTrasgressore.dataRilascioDocumento,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaTrasgressore.isMinorenne)
      sanzione.anagraficaTrasgressore.isMinorenne = 1;
    else sanzione.anagraficaTrasgressore.isMinorenne = 0;
    if (sanzione.anagraficaPotestaTrasgressore.dataDiNascita)
      sanzione.anagraficaPotestaTrasgressore.dataDiNascita = moment(
        sanzione.anagraficaPotestaTrasgressore.dataDiNascita,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento)
      sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento = moment(
        sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento,
        "DD/MM/YYYY"
      )
        .toDate()
        .getTime();
    if (sanzione.anagraficaPotestaTrasgressore.isMinorenne)
      sanzione.anagraficaPotestaTrasgressore.isMinorenne = 1;
    else sanzione.anagraficaPotestaTrasgressore.isMinorenne = 0;
    if (sanzione.isverbaleFattoABordo) sanzione.isverbaleFattoABordo = 1;
    else sanzione.isverbaleFattoABordo = 0;
    this.avanzaStatoPerDiverseAzioni(sanzione, idSaznione, idStato, onSuccess)
  }
  creaRateizza(sanzione,idSanzione, idSato, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };

    this.avanzaStatoPerDiverseAzioni(sanzione, idSanzione, idSato, onSuccess)

  }

  getDetailRata(IdSanzion, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(host + "/api/v1/sanzione/findRate/" + IdSanzion, configHeaders)
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("errore ricerca dettaglio sanzione " + error);
          onSuccess("");
        }
      );
  }

  pagaSanzioneORata(PagaSaznione,idSaznione, idStato, onSuccess, onError) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };

    this.avanzaStatoPerDiverseAzioni(PagaSaznione, idSaznione, idStato, onSuccess, onError)


  }

  dettaglioDiUnPagameto(numeroSanzione, IdRata, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(
        host + "/api/v1/sanzione/findRate/" + numeroSanzione + "/" + IdRata,
        configHeaders
      )
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("errore " + error);
          onSuccess("");
        }
      );
  }

  scontrinoSanzionePDF(numeroSanzione, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(host + "/api/v1/stampa/sanzione/" + numeroSanzione, configHeaders)
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("errore  " + error);
          onSuccess();
        }
      );
  }

  getListaTentativiPagamento(numeroSanzione, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(host + "/api/v1/payment/" + numeroSanzione, configHeaders)
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("errore " + error);
          onSuccess();
        }
      );
  }

  annullaTentativoPagamento(numeroSanzione, idTentativoPagamento, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .patch(
        host + "/api/v1/payment/" + numeroSanzione + "/" + idTentativoPagamento, "",
        configHeaders
      )
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("errore " + error);
          onSuccess(error.response);
        }
      );
  }

  getListaAllegatiSanzione(numeroSanzione, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(host + "/api/v1/file/lista/" + numeroSanzione, configHeaders)
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("errore " + error);
          onSuccess();
        }
      );
  }

  aggiungiAllegato(numeroSanzione, file, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .post(host + "/api/v1/file/save/" + numeroSanzione, file, configHeaders)
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("errore " + error);
          onSuccess();
        }
      );
  }

  detailAllegatoBase64(idAllegato, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios.get(host + "/api/v1/file/" + idAllegato, configHeaders).then(
      function (result) {
        if(result.status === 401){
          logOut();
        }
        onSuccess(result);
      },
      function (error) {
       if(error.response.status === 401){
          logOut();
        }
        console.log("errore " + error);
        onSuccess();
      }
    );
  }

  eliminaAllegato(numeroSanzione, idFile, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .post(
        host + "/api/v1/file/delete/" + numeroSanzione + "/" + idFile, "",
        configHeaders
      )
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("errore " + error);
          onSuccess();
        }
      );
  }

  getStoricoPagamenti(id,onSuccess,onError){
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };

    axios.get(host + "/api/v1/sanzione/getStorico/" + id,configHeaders)
    .then(
      function (result){
        if(result.status === 200){
          onSuccess(result.data);
        }else if(result.status === 401){
          logOut();
        }else{
          onError();
        }
      },
      function (error) {
        onError();
      }
    )
  }

  getRicevutaPagamento(id,idPagamento,onSuccess,onError){
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };

    axios.get(host + `/api/v1/sanzione/ricevuta/${id}/${idPagamento}`,configHeaders)
    .then(
      function (result){
        if(result.status === 200){
          onSuccess(result.data);
        }else if(result.status === 401){
          logOut();
        }else{
          onError();
        }
      },
      function (error) {
        onError();
      }
    )
  }


  validaIndirizzo(via, comune, provincia,cap,numero, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(
        host + `/api/v1/stradario/validazioneIndirizzo?via=${via}&numero=${numero}&comune=${comune}&provincia=${provincia}&cap=${cap}`,
        configHeaders
      )
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("errore " + error);
          onSuccess();
        }
      );
  }
  getRecidivo(CF, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(
        host + `/api/v1/recidivi/find/${CF}`,
        configHeaders
      )
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("errore  " + error);
          onSuccess();
        }
      );
  }

  getRecidivoById(id, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(
        host + `/api/v1/recidivi/find?id=${id}`,
        configHeaders
      )
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("errore  " + error);
          onSuccess();
        }
      );
  }


  invioMail(email, numSanz,  onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(
        host + `/api/v1/inviomail/${numSanz}/${email}`,
        configHeaders
      )
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("errore " + error);
          onSuccess();
        }
      );
  }

  attoIngiuntivo(sanzione,idSanzione,  onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .put(
        host + `/api/v1/sanzione/generateIngiunzione/${idSanzione}`,sanzione,
        configHeaders
      )
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("errore " + error);
          onSuccess();
        }
      );
  }
  impostazioniSpese(onSuccess) {
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    let host = process.env.REACT_APP_API_URL;
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      }
    };
   axios.get(host+"/api/v1/impostazioni/find/imp", configHeaders).then(function(result){
      if(result.status === 401){
        logOut();
      }
        onSuccess(result.data);
    }, function(error){
     if(error.response.status === 401){
        logOut();
      }
        console.log("Errore di  "+error);
        onSuccess("");
    });
  }
}
